export const DATA_GRID_STATE_KEY = 'nutrisense:users:appointments:dataGrid:state'
